import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { Lease } from "@eres/ejari-api/Entity";
import React, { Component, MouseEvent, useCallback } from "react";
import { PortfolioContext, ProxyPortfolio, TopInfo, XInfo } from "@my-dld/contexts/PortfolioContext";
import Strings from "@my-dld/assets/strings";
import { CurrencyUtil } from "@eres/core";
import { navigate, navigateWithInParent } from "@my-dld/utils/StoreUtils";
import _ from "lodash";
import HighchartsReact from "highcharts-react-official";
import PageTitle from "@my-dld/components/PageTitle";
import Popup from "../../../components/Popup/Popup";
import { resetLeasedContext } from "@eres/ejari-core/contexts/LeasedContext";
import { getLocalValue } from "@eres/core/dist/LocaleValue";
import { FixCapNameX } from "@my-dld/utils/Utils";

interface Props {
	cards?: AssetCard[];
	leases?: Lease[];
}

class Summary extends Component<Props> {

	onMyRequests = ( e: MouseEvent<HTMLAnchorElement> ) => {
		e.preventDefault();
		navigate( "/mydld/my_requests" );
	};

	onTWIMC = ( e: MouseEvent<HTMLAnchorElement> ) => {
		e.preventDefault();
		navigate( "/mydld/taburequest/twimc" );
	};

	render() {
		return <>
            <PageTitle title={Strings.my_portfolio} />
            <div className="panel-msg">
                <div><i className="material-icons-rounded me-2">error</i> As per our records, your Emirates ID is expired. Kindly update for uninterrupted services</div>
                <a href="#" className="btn-link"><i className="material-icons-rounded">autorenew</i> Update</a>
            </div>
            <div className="row g-3">
                {/*<div><DashboardSectionTitle title={Strings.my_portfolio} /></div>*/}
				<OwnedCard/>
				<ProxyCards/>
				<LeaseCard/>
                <EjariPropertiesCard />
                <SummaryChart />
                {/*<div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
					<a href="#" className="card" onClick={ this.onTWIMC }>
						<div className="card-body">
                            <div className="card-title-wrap">
                                <span className="card-title">
                                    <i className="icon-ejari-contract"></i>
                                    <span>{Strings.to_whom_it_may_concern}</span>
                                </span>
							</div>
							<div className="my-property-leased-description">{ Strings.twimc_description }</div>
						</div>
					</a>
				</div>*/}
				{/*<div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">*/}
				{/*	<a href="#" className="card" onClick={ this.onMyRequests }>*/}
				{/*		<div className="card-body">*/}
                {/*            <div className="card-title-wrap">*/}
                {/*                <span className="card-title">*/}
                {/*                    <i className="icon-mydld-request"></i>*/}
                {/*                    <span>{Strings.my_requests}</span>*/}
                {/*                </span>*/}
				{/*			</div>*/}
				{/*			<div className="my-property-leased-description">{ Strings.track_request }</div>*/}
				{/*		</div>*/}
				{/*	</a>*/}
				{/*</div>*/}
			</div>
		</>;
	}
}

// SH
export default Summary;

export function DashboardSectionTitle( props: { title: string } ) {
	return <div className="col-md-12">
		<div className="page-title">
			{ props.title }
		</div>
	</div>;
}

interface SPros<X> {
	id: string;
	title: string;
	sub_label: string;
	nav_label?: string;
	info: TopInfo;
	mergeBuilding?: boolean;
	isLoading: boolean;
	viewAll: () => void;
	iconClass: string;
}

class SummaryCard<X> extends Component<SPros<X>> {

	constructor( props: SPros<X> ) {
		super( props );
		this.state = {};
	}


	render() {
		const {
			info, title, sub_label, nav_label = Strings.view_all,
			mergeBuilding, isLoading, viewAll, iconClass,
		} = this.props;
		const hasData = info.all.count > 0;
		const bd = {
			label: Strings.villa,
			info: info.villas ? JSON.parse( JSON.stringify( info.villas ) ) as XInfo : {
				count: 0,
				value: 0,
			},
		};
		if ( hasData && mergeBuilding && info.buildings && info.buildings.count > 0 ) {
			bd.label = Strings.building_label;
			if ( bd.info ) {
				bd.info.count = bd.info.count + info.buildings.count;
				bd.info.value = bd.info.value + info.buildings.value;
				bd.info.percent = bd.info.value / info.all.value * 100;
			}
		}
		if ( !isLoading && !hasData ) return null;
		return (
            <div className="col-xl-4 col-lg-6 col-md-12 col-sm-12 col-12 card-ts2 das-card">
                <div className="card gap-0">
                    {isLoading && <CardLoading />}
                    <div className="card-body w-100">
                        <div className={iconClass}></div>
                        <div className="service-name">
                            <span className="property-number">{(info && info.all) ? info.all.count : "-"}</span>
                            <span>{title}</span>
                        </div>
                        <div className="current-investment">
                            <span>{CurrencyUtil.toSimpleCurrency((info && info.all) ? info.all.value : 0)} {Strings.aed}</span>
                            <span>{sub_label}</span>
                        </div>
                    </div>
                    {hasData &&
                        <div className="card-footer">
                            <a className="btn btn_1_outline" onClick={viewAll}>
                                {nav_label}
                            </a>
                        </div>
                    }
                </div>
            </div>
		);

	}
}

function ProxyCard( props: { portfolio: ProxyPortfolio<AssetCard> } ) {
	const { portfolio } = props;
	const { isLoading, info, id, name } = portfolio;
	const go = useCallback( () => {
		navigateWithInParent( "mydld", "owned/" + id );
	}, [ id ] );
	return <SummaryCard
		iconClass={ "icon-company-property" }
		viewAll={ go }
		isLoading={ isLoading }
		id={ "owned-cmp-" + id }
		title={ FixCapNameX( getLocalValue( name ) ) }
		sub_label={ Strings.current_investments }
		info={ info }/>;
}

class ProxyCards extends Component {
	static contextType = PortfolioContext;
	context!: React.ContextType<typeof PortfolioContext>;

	render(): React.ReactNode {
		const proxyAssets = this.context.proxyAssets;
		if ( proxyAssets && proxyAssets.length > 0 ) {
			return <>
				{ proxyAssets.map( ( value, index ) => {
					return <ProxyCard portfolio={ value } key={ value.id }/>;
				} ) }
			</>;
		}
		return null;
	}
}

class OwnedCard extends Component {
	static contextType = PortfolioContext;
	context!: React.ContextType<typeof PortfolioContext>;
	go = () => {
		navigateWithInParent( "mydld", "owned" );
	};

	render(): React.ReactNode {
		const { info, isLoading } = this.context.assets;
		return <SummaryCard
			iconClass={ "icon-owned-property" }
			viewAll={ this.go }
			isLoading={ isLoading }
			id={ "owned" }
			title={ Strings.owned_properties }
			sub_label={ Strings.current_investments }
			info={ info }/>;
	}
}

class LeaseCard extends Component {
	static contextType = PortfolioContext;
	context!: React.ContextType<typeof PortfolioContext>;
	go = () => {
		navigateWithInParent( "mydld", "my_leases" );
	};

	render(): React.ReactNode {
		const { info, isLoading } = this.context.leases;
		return <SummaryCard
			iconClass={ "icon-iam-tenant" }
			viewAll={ this.go }
			isLoading={ isLoading }
			id={ "leased" }
			title={ Strings.i_am_tenant }
			sub_label={ Strings.leased_amount }
			info={ info }
			mergeBuilding={ true }
		/>;
	}
}

class EjariPropertiesCard extends Component {
	go = () => {
		resetLeasedContext();
		navigateWithInParent( "mydld", "leased" );
	};

	render() {
        return <div className="col-xl-4 col-lg-6 col-md-12 col-sm-12 col-12 card-ts2 das-card">
            <div className="card gap-0 h-100">
                <div className="card-body w-100">
                    <div className="icon-lease-property"></div>
                    <div className="service-name">
                        {Strings.dash_ejari_properties_title}
                    </div>
                    <div className="service-description">{Strings.card_dash_ejari_properties_title}</div>
                </div>
                <div className="card-footer">
                    <a className="btn btn_1_outline" data-bs-toggle="modal" data-bs-target="#leasedPropertyInfo">{Strings.learn_more}</a>
                    <a className="btn btn_1_outline" onClick={this.go}>{ Strings.view_all }</a>
                </div>
			</div>
			<Popup
				id={ "leasedPropertyInfo" }
				title={ Strings.dash_ejari_properties_title }
				modalBodyContainer={ "modal-body" }
				showIcon={ false }
			>
				{ Strings.dash_ejari_properties_desc }
			</Popup>
		</div>;
	}
}

interface ChartState {
	loading: boolean;
	total: number;
	chartOptions?: any;
}

function doNothingEvent( e: any ) {
	e.preventDefault();
	return false;
}

class SummaryChart extends Component<any, ChartState> {
	static contextType = PortfolioContext;
	context!: React.ContextType<typeof PortfolioContext>;
	x = 0;

	constructor( props: any ) {
		super( props );
		this.state = {
			total: 0,
			loading: true,
			chartOptions: {},
		};
	}

	fromCtx = () => {
		const l = this.context.leases;
		const a = this.context.assets;
		const pa = this.context.proxyAssets.reduce( ( p, c ) => {
			return [ ...p, ...( c.all ?? [] ) ];
		}, [] as AssetCard[] );
		let total = 0;
		let owned = 0;
		let leased = 0;
		let px = 0;
		const loading = l.isLoading || a.isLoading;
		if ( !l.isLoading ) {
			leased = l.all?.length ?? 0;
			total = total + leased;
		}
		if ( !a.isLoading ) {
			owned = a.all?.length ?? 0;
			px = pa.length;
			total = total + owned + px;
		}
		let opt: any = {
			title: {
				text: "",
			},
			series: [],
		};
		if ( loading === false ) {
			const data: any[] = [];
			if ( owned > 0 ) {
				data.push( [ Strings.owned_properties, owned ], );
			}
			if ( px > 0 ) {
				data.push( [ Strings.company_properties, px ], );
			}
			if ( leased > 0 ) {
				data.push( [ Strings.i_am_tenant, leased ] );
			}
			opt = {
				chart: {
					plotBackgroundColor: undefined,
					plotBorderWidth: 0,
					plotShadow: false,
					//styledMode: true
				},
				title: {
					text: "<span class=\"property-value\">" + total + "</span><br><span class=\"property-label\">" + Strings.properties + "</span>",
					align: "center",
					verticalAlign: "middle",
					y: 30
				},
				tooltip: {
					pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
				},
				accessibility: {
					point: {
						valueSuffix: "%"
					}
				},
				legend: {
					//itemWidth: 130,
					itemStyle: {
						fontSize: "11px",
						color: "blue",
						textOverflow: "allow"
					},
					align: "center",
					layout: "horizontal",
					verticalAlign: "bottom",
					x: 0,
					y: 0
				},
				exporting: {
					enabled: false
				},
				plotOptions: {
					pie: {
						dataLabels: {
							enabled: false,
							distance: -80,
							style: {
								fontWeight: "bold",
								color: "black"
							}
						},
						startAngle: -90,
						endAngle: 90,
						center: [ "50%", "120%" ],
						size: "230%",
						showInLegend: true,
						point: {
							events: {
								legendItemClick: doNothingEvent,
							}
						}
					}
				},
				series: [ {
					type: "pie",
					innerSize: "90%",
					data: data
				} ]
			};
		}

		return {
			loading: loading,
			total,
			chartOptions: opt,
		} as ChartState;
	};

	componentDidMount() {
		this.setState( this.fromCtx() );
	}

	componentDidUpdate( prevProps: Readonly<any>, prevState: Readonly<ChartState>, snapshot?: any ) {
		const ns = this.fromCtx();
		if ( !_.isEqual( ns, this.state ) ) {
			this.setState( ns );
		}
	}

	render(): React.ReactNode {
		const {
			total,
			chartOptions,
			loading
		} = this.state;
		if ( !loading && total === 0 ) return null;
        return <div className="col-xl-4 col-lg-6 col-md-12 col-sm-12 col-12 card-ts2 das-card">
            <div className="card card-chart h-100 justify-content-center">
				{ loading && <CardLoading/> }
				<HighchartsReact
					options={ chartOptions }
					containerProps={ { className: "mydld-chart" } }
				/>
			</div>
		</div>;
	}
}

function CardLoading() {
    return <div className={ "position-absolute d-flex w-100 h-100 bg-white opacity-75 rounded-5 z-1" }>
		<div className={ "d-flex justify-content-center align-items-center align-self-stretch flex-fill" }>
			<div className="relative spinner-border spinner-border-no-shift" role="status">
				<span className="sr-only">Loading...</span>
			</div>
		</div>
	</div>;
}
